import React, { Component } from "react";
import { TweenLite, Power0 } from "gsap";

import "./Loading.css";

const DELAY_AFTER_CLOSE = 500;

export default class Loading extends Component {
	state = {
		componentShouldClose: false,
	};

	static defaultProps = {
		perc: 0,
	};

	componentWillReceiveProps = newProps => {
		if (newProps.perc === 1 && this.state.componentShouldClose === false) {
			this.closeComponent();
		}
	};

	closeComponent = () => {
		this.setState({ componentShouldClose: true });
		TweenLite.to(this.loading, 1, {
			autoAlpha: 0,
			ease: Power0.easeInOut,
			onComplete: () => {
				setTimeout(this.props.onComplete, DELAY_AFTER_CLOSE);
			},
		});
	};

	render() {
		const { perc } = this.props;

		return (
			<div
				className="Loading"
				ref={element => {
					this.loading = element;
				}}
			>{`Loading ${Math.ceil(perc * 100)}%`}</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Loading.js